import _extends from "@babel/runtime/helpers/esm/extends";
var _Country;
import React from 'react';
import { Badge } from '../Badge';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Checkbox } from '@im/ui-lib/zenith/Checkbox';
import { Avatar } from '../Avatar/Avatar';
import Typography from '@mui/material/Typography';
import { Country, XClose } from '../common/im-theme-icons';
import { IndicatorBadgeDot } from '../IndicatorBadge/IndicatorBadgeDot';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var padding = {
  'avatar-label-badge-lg': '4px 4px 4px 7px',
  'avatar-label-badge-md': '2px 3px 2px 5px',
  'avatar-label-badge-sm': '3px 4px',
  'avatar-label-lg': '4px 10px 4px 7px',
  'avatar-label-md': '2px 9px 2px 5px',
  'avatar-label-sm': '3px 8px 3px 4px',
  'avatar-label-xclose-lg': '4px 4px 4px 7px',
  'avatar-label-xclose-md': '2px 4px 2px 5px',
  'avatar-label-xclose-sm': '3px 4px',
  'checkbox-avatar-label-badge-lg': '4px 4px 4px 5px',
  'checkbox-avatar-label-badge-md': '2px 3px 2px 4px',
  'checkbox-avatar-label-badge-sm': '3px 4px 3px 5px',
  'checkbox-avatar-label-lg': '4px 10px 4px 5px',
  'checkbox-avatar-label-md': '2px 9px 2px 4px',
  'checkbox-avatar-label-sm': '3px 8px 3px 5px',
  'checkbox-avatar-label-xclose-lg': '4px 4px 4px 5px',
  'checkbox-avatar-label-xclose-md': '2px 4px',
  'checkbox-avatar-label-xclose-sm': '3px 4px 3px 5px',
  'checkbox-dot-label-badge-lg': '4px 4px 4px 5px',
  'checkbox-dot-label-badge-md': '2px 3px 2px 4px',
  'checkbox-dot-label-badge-sm': '3px 4px 3px 5px',
  'checkbox-dot-label-lg': '4px 10px 4px 5px',
  'checkbox-dot-label-md': '2px 9px 2px 4px',
  'checkbox-dot-label-sm': '3px 8px 3px 5px',
  'checkbox-dot-label-xclose-lg': '4px 4px 4px 5px',
  'checkbox-dot-label-xclose-md': '2px 4px',
  'checkbox-dot-label-xclose-sm': '3px 4px 3px 5px',
  'checkbox-label-badge-lg': '4px 4px 4px 5px',
  'checkbox-label-badge-md': '2px 3px 2px 4px',
  'checkbox-label-badge-sm': '3px 4px 3px 5px',
  'checkbox-label-lg': '4px 10px 4px 5px',
  'checkbox-label-md': '2px 9px 2px 4px',
  'checkbox-label-sm': '3px 8px 3px 5px',
  'checkbox-label-xclose-lg': '4px 4px 4px 5px',
  'checkbox-label-xclose-md': '2px 4px',
  'checkbox-label-xclose-sm': '3px 4px 3px 5px',
  'dot-label-badge-lg': '4px 4px 4px 9px',
  'dot-label-badge-md': '2px 3px 2px 7px',
  'dot-label-badge-sm': '3px 4px 3px 6px',
  'dot-label-lg': '4px 10px 4px 9px',
  'dot-label-md': '2px 9px 2px 7px',
  'dot-label-sm': '3px 8px 3px 6px',
  'dot-label-xclose-lg': '4px 4px 4px 9px',
  'dot-label-xclose-md': '2px 4px 2px 7px',
  'dot-label-xclose-sm': '3px 4px 3px 6px',
  'label-badge-lg': '4px 4px 4px 10px',
  'label-badge-md': '2px 3px 2px 9px',
  'label-badge-sm': '3px 4px 3px 8px',
  'label-lg': '4px 10px',
  'label-md': '2px 9px',
  'label-sm': '3px 8px',
  'label-xclose-lg': '4px 4px 4px 10px',
  'label-xclose-md': '2px 4px 2px 9px',
  'label-xclose-sm': '3px 4px 3px 8px'
};
var Label = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.gray[700]
  };
});
var StyledAvatar = styled(Avatar)(function () {
  return {
    borderRadius: 133,
    height: 16,
    width: 16
  };
});
var CheckboxLG = styled(Checkbox)(function () {
  return {
    borderRadius: 4,
    height: 18,
    width: 18
  };
});
export function Tag(props) {
  var _Badge, _StyledXClose;
  var action = props.action,
    checkboxProps = props.checkboxProps,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    counter = props.counter,
    _props$dotIntent = props.dotIntent,
    dotIntent = _props$dotIntent === void 0 ? 'success' : _props$dotIntent,
    icon = props.icon,
    imageSrc = props.imageSrc,
    _props$isCheckboxEnab = props.isCheckboxEnabled,
    isCheckboxEnabled = _props$isCheckboxEnab === void 0 ? false : _props$isCheckboxEnab,
    label = props.label,
    onChangeCheckbox = props.onChangeCheckbox,
    onClose = props.onClose,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    sx = props.sx;
  var theme = useTheme();
  var getIconSize = function getIconSize() {
    switch (size) {
      case 'lg':
        return {
          fontSize: 14,
          height: 14,
          width: 14
        };
      case 'md':
        return {
          fontSize: 12,
          height: 12,
          width: 12
        };
      case 'sm':
        return {
          fontSize: 10,
          height: 10,
          width: 10
        };
    }
  };
  var getSpacingDetails = function getSpacingDetails() {
    switch (size) {
      case 'lg':
        return {
          gap: 6,
          marginLeft: '-3px'
        };
      case 'md':
        return {
          gap: 5,
          marginLeft: '-2px'
        };
      case 'sm':
        return {
          gap: 4,
          marginLeft: '-1px'
        };
    }
  };
  var paddingKey = '';
  if (isCheckboxEnabled) paddingKey = 'checkbox-';
  if (icon === 'avatar') paddingKey += 'avatar-';
  if (icon === 'dot') paddingKey += 'dot-';
  paddingKey += 'label-';
  if (action === 'xClose') paddingKey += 'xclose-';
  if (action === 'count') paddingKey += 'badge-';
  paddingKey += "".concat(size);
  var Tag = styled(Box)(function () {
    return {
      alignItems: 'center',
      border: "1px solid ".concat(theme.palette.gray[300]),
      borderRadius: 6,
      display: 'flex',
      gap: getSpacingDetails().gap,
      justifyContent: 'space-evenly',
      maxHeight: size === 'lg' ? 36 : 28,
      maxWidth: 'fit-content',
      padding: padding[paddingKey]
    };
  });
  var StyledXClose = styled(XClose)(function () {
    return _extends({
      color: "".concat(theme.palette.gray[400], " !important"),
      cursor: 'pointer',
      marginLeft: getSpacingDetails().marginLeft
    }, getIconSize());
  });
  var renderBadgeOrXClose = function renderBadgeOrXClose() {
    switch (action) {
      case 'count':
        return _Badge || (_Badge = /*#__PURE__*/_jsx(Badge, {
          label: counter,
          size: size,
          type: "badgeColor"
        }));
      case 'xClose':
        return _StyledXClose || (_StyledXClose = /*#__PURE__*/_jsx(StyledXClose, {
          onClick: onClose
        }));
    }
  };
  var renderCheckbox = function renderCheckbox() {
    switch (size) {
      case 'lg':
        return /*#__PURE__*/_jsx(CheckboxLG, _extends({
          checked: checked,
          onChange: onChangeCheckbox
        }, checkboxProps));
      default:
        return /*#__PURE__*/_jsx(Checkbox, _extends({
          checked: checked,
          onChange: onChangeCheckbox
        }, checkboxProps, {
          size: "sm"
        }));
    }
  };
  return /*#__PURE__*/_jsxs(Tag, {
    sx: sx,
    "data-element": "Tag",
    "data-component": "Tag",
    "data-source-file": "Tag.tsx",
    children: [isCheckboxEnabled && renderCheckbox(), icon === 'avatar' && /*#__PURE__*/_jsx(StyledAvatar, {
      size: "xs",
      src: imageSrc
    }), icon === 'dot' && /*#__PURE__*/_jsx(IndicatorBadgeDot, {
      intent: dotIntent,
      size: "xs"
    }), icon === 'country' && (_Country || (_Country = /*#__PURE__*/_jsx(Country, {}))), /*#__PURE__*/_jsx(Label, {
      variant: size === 'sm' ? 'text-xs-medium' : 'text-sm-medium',
      "data-element": "Label",
      "data-source-file": "Tag.tsx",
      children: label
    }), renderBadgeOrXClose()]
  });
}